'use client';

import { useState } from 'react';

import { CloudinaryCropResize, CloudinaryGravity } from '../image/types';
import { ImageGalleryWrapper, MinifiedImageContainer, SelectedImageContainer } from './image-gallery.styles';
import { FragmentType, getFragmentData } from '@gql';
import { ImageFragment } from 'lib/shared/content-posts-gql';
import { getImage } from 'utils/get-image';

import { Column, Grid, Image } from 'components/aurora/';

type Image = FragmentType<typeof ImageFragment>;

export function ImageSelector(props: FragmentType<typeof ImageFragment>) {
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const post = getFragmentData(ImageFragment, props);

  const mainImage = getImage(post.image?.[selectedImageIndex]?.assetConnection);

  if (!mainImage) return null;

  return (
    <ImageGalleryWrapper>
      <Grid $gap={post?.image && post.image?.length > 1 ? 'gutter' : 'none'}>
        <Column
          $span={{
            xs: 12,
          }}
        >
          {mainImage ? (
            <SelectedImageContainer>
              <Image
                alt={mainImage.description || ''}
                imageId={mainImage.id || ''}
                imageSuffix={mainImage.suffix || ''}
                gravity={(post?.image?.[selectedImageIndex]?.gravity as CloudinaryGravity) || 'g_center'}
                crop_resize={(post?.image?.[selectedImageIndex]?.crop_resize as CloudinaryCropResize) || 'c_fit'}
                withAspectRatio={true}
                width={mainImage?.dimension?.width}
                height={mainImage.dimension?.height}
              />
            </SelectedImageContainer>
          ) : null}
        </Column>

        {post?.image && post.image?.length > 1
          ? post.image?.map((img, index: number) => {
              const imageData = getImage(img?.assetConnection);
              return (
                <Column
                  $span={{ xs: 5, lg: 4 }}
                  key={index}
                >
                  <MinifiedImageContainer onClick={() => setSelectedImageIndex(index)}>
                    <Image
                      key={index}
                      alt={img?.alt_text || ''}
                      imageId={imageData?.id || ''}
                      imageSuffix={imageData?.suffix || ''}
                      gravity={(img?.gravity as CloudinaryGravity) || ''}
                      crop_resize={(img?.crop_resize as CloudinaryCropResize) || ''}
                    />
                  </MinifiedImageContainer>
                </Column>
              );
            })
          : null}
      </Grid>
    </ImageGalleryWrapper>
  );
}
